import { useEffect, useState } from "react";
import { ModalCustom } from "components/ModalCustom";
import {
  ModalBody,
  Subtitle,
  SwitchWrapper,
  ToggleLabel,
  ToggleRow,
} from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  configColunas: { nome: string; exibir: boolean }[];
  onSave: (config: { nome: string; exibir: boolean }[]) => void;
}

const colunaLabels: Record<string, string> = {
  id: "ID",
  placa: "PLACA",
  renavam: "RENAVAM",
  chassi: "CHASSI",
  dataCadastroProcesso: "DT. CADASTRO PROCESSO",
  escolhaPlaca: "ESCOLHA DE PLACA",
  numeroProcesso: "NÚMERO PROCESSO",
  dataHoraProcesso: "DT / HR PROCESSO",
  despachante: "DESPACHANTE",
  agenteFinanceiro: "AGENTE FINANCEIRO",
  codigoBarras: "CÓDIGO DE BARRAS",
  valorDataVencimento: "VALOR / DT VENCIMENTO",
  escPla: "ESC PLA",
  gp: "GP",
  taxa: "TAXA",
  gpd: "GPD",
  ap: "AP",
  lic: "LIC",
  pla: "PLA",
  ipva: "IPVA",
  blo: "BLO",
  fin: "FIN",
  info: "INFO",
};

export function ModalConfigColunas({
  show,
  handleClose,
  configColunas,
  onSave,
}: IProps) {
  const [tempConfig, setTempConfig] = useState(configColunas);

  useEffect(() => {
    if (show) setTempConfig(configColunas);
  }, [show]);

  const allSelected = tempConfig.every((c) => c.exibir);

  function toggleAll() {
    setTempConfig(tempConfig.map((c) => ({ ...c, exibir: !allSelected })));
  }

  function toggleColuna(nome: string) {
    setTempConfig(
      tempConfig.map((c) =>
        c.nome === nome ? { ...c, exibir: !c.exibir } : c,
      ),
    );
  }

  function handleSave() {
    onSave(tempConfig);
    handleClose();
  }

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Configurar visualização de colunas"
      centered
      footer
      footerConfirmButton
      onConfirm={handleSave}
      confirmButtonText="Salvar"
    >
      <ModalBody>
        <Subtitle>
          Selecione as colunas que deseja visualizar na sua tabela.
        </Subtitle>
        <ToggleRow>
          <ToggleLabel bold>Colunas</ToggleLabel>
          <SwitchWrapper>
            <input type="checkbox" checked={allSelected} onChange={toggleAll} />
            <span />
          </SwitchWrapper>
        </ToggleRow>
        {tempConfig.map((col) => (
          <ToggleRow key={col.nome}>
            <ToggleLabel>{colunaLabels[col.nome] ?? col.nome}</ToggleLabel>
            <SwitchWrapper>
              <input
                type="checkbox"
                checked={col.exibir}
                onChange={() => toggleColuna(col.nome)}
              />
              <span />
            </SwitchWrapper>
          </ToggleRow>
        ))}
      </ModalBody>
    </ModalCustom>
  );
}
